import React, { useState, useEffect } from 'react'
import { Typography } from 'antd'
import { ScrollToTop, Loader } from 'components'
import { AnButtonGradient } from 'components/an'
import { Link } from "react-router-dom"
import Animate from 'rc-animate'

const LoginClientStepTwo = React.memo((props) => {
    const {
        isMobile,
        image,
    } = props

    const [show, setShow] = useState(isMobile ? false : true)

    useEffect(() => {
        setTimeout(() => {
            setShow(true)
        }, 500)
    }, [setShow])

    return (
        <>
            <ScrollToTop behavior="auto" />
            
            <Loader loading={!show} />
            
            <Animate
                transitionName="zoom"
                transitionAppear
            >
                {(show && (
                    <div className="login-screen-iwrap">
                        <div className='login-img'>
                            <img
                                src={image}
                                alt='Login Spiderweb'
                            />
                        </div>
                        
                        <div className="login-comp-container">
                            <h1
                                style={{
                                    margin: 0
                                }}
                            >
                                Ingresar
                            </h1>

                            <Typography.Text
                                type='secondary'
                                style={{
                                    marginBottom: 15,
                                    textAlign: 'center'
                                }}

                            >
                                Te enviamos un correo con un link
                                para que puedas autenticarte en la
                                plataforma. Haz click en el link y listo!
                            </Typography.Text>
                            
                            <Link
                                to='/search'
                            >
                                <AnButtonGradient
                                    type="primary"
                                    shape='round'
                                    size='large'

                                >
                                    De acuerdo!
                                </AnButtonGradient>
                            </Link>
                        </div>
                    </div>
                ))}
            </Animate>
        </>
    )
})

export default LoginClientStepTwo